import React from 'react';
import { Smartphone, Layout } from 'lucide-react';
import { cn } from "@/lib/utils/cn";

export type PostFormat = 'post' | 'story' | null;

interface FormatSelectorProps {
  format: PostFormat;
  setFormat: (format: PostFormat) => void;
  disableStory?: boolean;
}

export const FormatSelector: React.FC<FormatSelectorProps> = ({ format, setFormat, disableStory }) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-gray-700">Format</label>
        {disableStory && (
          <span className="text-xs text-orange-600 bg-orange-50 px-2 py-1 rounded-md">Story nicht verfügbar mit aktueller Auswahl</span>
        )}
      </div>
      <div className="grid grid-cols-2 gap-3">
         <button
          type="button"
          onClick={() => !disableStory && setFormat(format === 'story' ? null : 'story')}
          disabled={disableStory}
          className={cn(
            "flex items-center gap-3 p-3 rounded-xl border-2 transition-all text-left",
            format === 'story' 
              ? "border-gray-800 bg-gray-50" 
              : "border-gray-200 hover:border-gray-300 hover:bg-gray-50",
            disableStory && "opacity-50 cursor-not-allowed bg-gray-50 border-gray-100"
          )}
        >
          <div className={cn("p-2 rounded-lg transition-colors", format === 'story' ? "bg-gray-800 text-white" : "bg-gray-100 text-gray-500")}>
            <Smartphone className="h-5 w-5" />
          </div>
          <div>
            <div className="text-sm font-medium text-gray-900">Story</div>
            <div className="text-xs text-gray-500">9:16 Portrait</div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => setFormat(format === 'post' ? null : 'post')}
          className={cn(
            "flex items-center gap-3 p-3 rounded-xl border-2 transition-all text-left",
            format === 'post' 
              ? "border-gray-800 bg-gray-50" 
              : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
          )}
        >
          <div className={cn("p-2 rounded-lg transition-colors", format === 'post' ? "bg-gray-800 text-white" : "bg-gray-100 text-gray-500")}>
            <Layout className="h-5 w-5" />
          </div>
          <div>
            <div className="text-sm font-medium text-gray-900">Post</div>
            <div className="text-xs text-gray-500">1:1 Quadrat</div>
          </div>
        </button>
      </div>
    </div>
  );
};
